<sb-info-card
  [title]="'Knowledge Base' | translate"
  [linkLabel]="'Go to Knowledge Base' | translate"
  (linkClick)="openHelpCenter()"
>
  {{
    'Search step-by-step guides and FAQs to solve specific questions about scheduling, timesheets, integrations, and more.'
      | translate
  }}
</sb-info-card>
@if (canAccessAcademy()) {
  <sb-info-card
    [title]="'Shiftbase Academy' | translate"
    [linkLabel]="'Go to Shiftbase Academy' | translate"
    (linkClick)="openAcademy()"
  >
    {{
      'Follow guided video courses (20-90 min) to master planning strategies and build complete workflow skills.'
        | translate
    }}
  </sb-info-card>
}
